module.exports = __webpack_public_path__ + "static/media/speed-icon.3b51726b.svg";